import React, { useCallback } from 'react';
import { useTranslate } from '@agilepoint/wat-react';
import { SecondaryButton, Typography } from '@agilepoint/wat-react-ux';
import { useCustomPopupEvents } from 'lib/hooks';
import { StyledActionButton, StyledPrimaryButton } from 'common';

const renderPopupContent = () => (
    <Typography.Small>
        This will reset the entire Default App Settings. Do you want to continue?
    </Typography.Small>
);

interface IResetButtonProps {
    onReset: () => Promise<void>
}

export const ResetButton = React.memo((props: IResetButtonProps) => {
    const { showCustomPopup, removePopup } = useCustomPopupEvents();
    const translate = useTranslate();

    const onOkClick = useCallback(() => {
        props.onReset().then(() => removePopup('reset-default-settings'));
    }, [props, removePopup]);

    const onCancelClick = useCallback(() => {
        removePopup('reset-default-settings');
    }, [removePopup]);

    const onReset = useCallback(() => {
        showCustomPopup({
            headerTitle: translate('modules.maaTitle.mobileAppAcceleratorTitle'),
            showModal: true,
            id: 'reset-default-settings',
            width: '700px',
            onRenderContent: renderPopupContent,
            onRenderFooter: () => (
                <>
                    <StyledActionButton label={translate('common.actions.cancel')} onClick={onCancelClick} />
                    <StyledPrimaryButton label={translate('common.actions.ok')} onClick={onOkClick} />
                </>
            )
        });
    }, [onCancelClick, onOkClick, showCustomPopup, translate]);

    return (
        <SecondaryButton label={translate('common.actions.reset')} onClick={onReset} />
    );
});
